module.exports = __webpack_public_path__ + "static/media/03_sendto_context_menu.4f59502f.PNG";